import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SetupProducer = lazy(
  () => import('@pages/producer/SetupProducer/index'),
);

const SetupProducerRoutes: RouteObject[] = [
  {
    path: '/setup-producer',
    element: (
      <React.Suspense>
        <SetupProducer />
      </React.Suspense>
    ),
    children: [],
  },
];

export default SetupProducerRoutes;